module.exports = __webpack_public_path__ + "static/media/img_placeholder.62249846.svg";